export const MAX_FILE_SIZE_BYTES = 5120000
export const MAX_FILE_QUANTITY = 3
export const ALLOWED_FEATURED_IMAGE_TYPES = 'image/jpeg,image/png'
export const ALLOWED_ATTACHMENT_TYPES =
  'image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
